// extracted by mini-css-extract-plugin
export default {"change-log":"ChangeLog_change-log__RntM2"};